module.exports = __webpack_public_path__ + "static/media/mailblast.8a4dc6f5.svg";